import React, { useContext, useState } from "react";
import searchIcon from "../assets/images/svg/search.svg";
import profileIcon from "../assets/images/svg/profile.svg";
import logoIcon from "../assets/images/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HoverMenu from "./HoverMenu";
import CartModal from "./CartModal";
import UserModal from "./UserModal";
import Drawer from "./Drawer";
import SearchDrawer from "./SearchDrawer";
import { Context } from "../context/MainContext";

const TopBar = () => {
  const { user } = useContext(Context);
  const [name, setName] = useState("");

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleSearch = () => {
    if (name) {
      navigate(`shop/${name}`);
      // setName("");
    }
  };

  const link = [
    { name: "Home", link: "/" },
    { name: "About us", link: "/about" },
    {
      name: "Products",
      link: "/products",
    },
    { name: "Services", link: "/services" },
    { name: "Training", link: "/training" },
    { name: "News", link: "/news" },
    // { name: "Blog", link: "/blog" },
    { name: "Contact", link: "/contact" },
  ];

  return (
    <nav className="topbar">
      <div className="topbar__top">
        <div className="topbar__top__left">
          <p>
            <i class="bxf bx-heart"></i> Welcome to Chaol Carington Ltd. We
            provide quality products and services.
          </p>
          <a href="tel:+2347041410503">
            <i class="bx bx-phone"></i> +234 704 1410 503
          </a>
          {/* <a href="tel:029168261">
             +234 908 7327 323
          </a> */}
        </div>
        <div className="topbar__top__right">
          {/* <Link className="topbar__top__right__acc" to="/account">
            <i class="bx bx-user-circle"></i>
            <span>
              {user?.id ? `${user?.firstName} ${user?.lastName}` : "My account"}
            </span>
          </Link> */}
          <CartModal />
          <UserModal />
        </div>
      </div>
      <div className="topbar__main">
        <Link to="/">
          <img src={logoIcon} alt="" className="topbar__main__logo" />
        </Link>

        <ul className="topbar__main__center">
          {link.map((item) => (
            <>
              {item.name !== "Products" ? (
                <li key={item.name}>
                  <Link
                    to={item.link}
                    className={pathname === item.link ? "active" : ""}
                  >
                    {item.name}
                  </Link>
                </li>
              ) : (
                <HoverMenu links={item} pathname={pathname} />
              )}
            </>
          ))}
          {/* <li>
            <Link to="/shop">Shop</Link>
            </li> */}
        </ul>

        <div className="topbar__main__right">
          {/* <SearchDrawer /> */}

          <div className="topbar__main__form">
            <input
              placeholder="Search..."
              type="text"
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
            <button onClick={handleSearch}>
              <img src={searchIcon} alt="" />
            </button>
          </div>

          <Drawer links={link} />
          {/* <div className="topbar__main__right__menu">
            <i className="bx bx-menu"></i>
          </div> */}
        </div>
      </div>
    </nav>
  );
};

export default TopBar;
